import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-32 md:py-40 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20modern%20minimal%20product%20display%20with%20soft%20natural%20lighting%2C%20clean%20scandinavian%20showroom%20aesthetic%2C%20warm%20neutral%20cream%20and%20beige%20tones%2C%20elegant%20curated%20fashion%20items%20arrangement%2C%20professional%20commercial%20photography%2C%20no%20text%20no%20watermark&width=1800&height=900&seq=cta-bg-final-05&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/45"></div>

      <div className="relative z-10 px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight lowercase max-w-xl">
            {t('cta_title')}
          </h2>

          <div className="flex flex-col gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-3 bg-white text-foreground-900 px-8 py-4 rounded-full text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>{t('btn_buy_now')}</span>
              <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="mt-10">
          <p className="text-white/70 text-sm md:text-base leading-relaxed">
            {t('cta_desc_line1')}<br />
            {t('cta_desc_line2')}
          </p>
        </div>
      </div>
    </section>
  );
}